import { Kanban } from '../../../../_services/kanban/kanban.model'

export type Operator = Kanban.Card.Filters.Operator

export const FIXED_CARD_FIELD_IDS: ReadonlySet<Kanban.Card.Filters.Fixed['id']> = new Set([
  'title',
  'phaseId',
  'assignedTo',
  'shopId',
  'cameraId',
  'date',
  'dueDate',
  'tagId'
])

type FilterField =
  | {
      fixed: true
      id: Kanban.Card.Filters.Fixed['id']
    }
  | {
      fixed: false
      id: string
    }

export const OPERATOR_SYMBOLS: Record<Operator, string> = {
  eq: '=',
  neq: '≠',
  gt: '>',
  gte: '≥',
  lt: '<',
  lte: '≤',
  is: 'é',
  cs: '∈'
}

export type KanbanCheckFilter = {
  type: 'check'
  key?: string
  field: FilterField
  label: string
  value: string
  operator?: Operator
  defaultActive?: boolean
}

export type KanbanSelectFilter = {
  type: 'select'
  key?: string
  field: FilterField
  label: string
  options: { label: string; value: string }[]
  operator?: Operator
  defaultValue?: string
}

export type KanbanDateFilter = {
  type: 'date'
  key?: string
  field: FilterField
  label: string
  operator?: Operator
  defaultValue?: string
}

export type KanbanTextFilter = {
  type: 'text'
  key?: string
  field: FilterField
  label: string
  placeholder?: string
  operator?: Operator
  defaultValue?: string
}

export type KanbanPropertyFilter = {
  type: 'property'
  key?: string
  field: FilterField
  label: string
  operators: Operator[]
  defaultValue?: { operator: Operator; value: string }
}

export type KanbanMultiSelectFilter = {
  type: 'multiselect'
  key?: string
  field: FilterField
  label: string
  options: { label: string; value: string }[]
  operator?: Operator
  defaultValue?: string[]
}

export type KanbanFilter =
  | KanbanCheckFilter
  | KanbanSelectFilter
  | KanbanDateFilter
  | KanbanTextFilter
  | KanbanPropertyFilter
  | KanbanMultiSelectFilter

export function filterKey(filter: KanbanFilter): string {
  return filter.key ?? filter.field.id
}

export const DEFAULT_KANBAN_FILTERS: KanbanFilter[] = [
  {
    type: 'check',
    key: 'user',
    field: { fixed: true, id: 'assignedTo' },
    label: 'Minhas tarefas',
    value: 'me'
  },
  {
    type: 'select',
    key: 'user',
    field: { fixed: true, id: 'assignedTo' },
    label: 'Usuário',
    options: []
  },
  {
    type: 'select',
    field: { fixed: true, id: 'shopId' },
    label: 'Loja',
    options: []
  },
  {
    type: 'text',
    field: { fixed: true, id: 'cameraId' },
    label: 'Câmera',
    placeholder: 'Buscar câmera...'
  },
  {
    type: 'date',
    field: { fixed: true, id: 'date' },
    label: 'Data de criação',
    operator: 'eq'
  },
  {
    type: 'select',
    key: 'tags',
    field: { fixed: true, id: 'tagId' },
    label: 'Tag',
    options: [],
    operator: 'cs'
  },
  {
    type: 'multiselect',
    field: { fixed: true, id: 'phaseId' },
    label: 'Fases',
    options: []
  }
]

export type PropertyValue = { operator: Operator; value: string }
export type DateRangeValue = { start: string; end: string }
export type FilterValue = string | PropertyValue | DateRangeValue | string[] | null

export type AdvancedFilterEntry = { operator: Operator; value: string; rangeEnd?: string }
export type AdvancedFilters = Record<string, AdvancedFilterEntry>

export type KanbanFiltersChange = {
  field: FilterField
  operator: Operator
  value: string
}[]
